<template lang='pug'>
  .fpui-input-file-zone(
    :class="{ dropAreaDragging: dragging, error: hasError || error, active: active}"
    @click='onClick'
    @dragenter.prevent.stop="dragging = true"
    @dragleave="dragging = false"
    @dragover.prevent.stop='onDragover'
    @drop.prevent.stop='onDrop'
  )
    input(ref='input' type='file', v-show='false', :input='value', @input='onInput')
    .max-size(v-if='maxSize')
      i.fpui.fpui-chevron-left
      span {{ size() }}
    slot
    .content-without-slot(v-if='!hasSlot')
      .content-file(v-if='value && value.name')
        span {{ value.name }} - {{ size(value.size) }}
      .placeholder(v-else)
        span {{ placeholder }}
</template>

<script>

export default {
  props: {
    value: { required: true },
    accept: { type: String },
    maxSize: { type: Number },
    placeholder: { type: String },
    error: { type: Boolean }
  },
  data () {
    return {
      dragging: false,
      active: false,
      hasError: false
    }
  },
  computed: {
    hasSlot () { return !!this.$slots.default }
  },
  methods: {
    onClick (e) {
      this.$refs.input.click()
      this.$emit('click', e)
    },
    onDragover (event) {
      this.hasError = false
      this.active = false
      this.dragging = true
      let effect
      try {
        effect = event.dataTransfer.effectAllowed
      } catch (error) {
        // eslint-disable-next-line
      }
      event.dataTransfer.dropEffect = effect === 'move' || effect === 'linkMove' ? 'move' : 'copy'
      this.$emit('drag-over', event)
    },
    onInput (e) {
      if (e.target.files && e.target.files.length > 0) {
        this.handleFile(e.target.files[0])
      }
    },
    onDrop (event) {
      this.dragging = false
      let files = event.dataTransfer.files
      if (files && files.length > 0) {
        this.handleFile(files[0])
      }
    },
    handleFile (file) {
      if (!this.checkFile(file)) {
        this.hasError = true
        this.$emit('input', file)
        return
      }
      this.hasError = false
      this.active = true
      this.$emit('input', file)
    },
    checkFile (file) {
      if ((this.accept && this.accept.indexOf(file.type) === -1) || !file.type) {
        return false
      }
      if (this.maxSize && file.size > this.maxSize) {
        return false
      }
      return true
    },
    size (val) {
      val = val || this.maxSize
      let i
      let value
      const dict = ['Ko', 'Mo', 'Go', 'To']
      const round = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
      i = 0
      value = val / 1024
      while (value > 1000) {
        i++
        value = value / 1024
      }
      if (dict[i] !== 'Mo' && dict[i] !== 'Ko') {
        return `${round(value || 0, 2)} ${dict[i]}`
      } else {
        return `${round(value || 0, 0)} ${dict[i]}`
      }
    }
  }
}
</script>

<style lang='less'>
  @import "~@/shared/styles/_variables.less";

  .fpui-input-file-zone {
    clear: both;
    width: 100%;
    box-shadow: none;
    display: inline-block;
    text-align: center;
    border:2px dashed #ddd;
    height: 170px;
    cursor: pointer;
    position: relative;
    .max-size {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    &.dropAreaDragging, &.active, &:hover {
      border-color: @blue;
    }
    &.error {
      border-color: @red;
    }
  }
</style>
